<div class="flx-modal" role="dialog" aria-modal="true">
  <!-- Section 1: Add New Status -->
  <div class="flx-modal__header w-f3">
    <div class="with-desc">
      <h2>1. {{data?.mode ? translate?.general.buttons.edit.singular : translate?.general.buttons.add.singular + ' ' + translate?.general.buttons.new.singular}} {{translate?.setup.modules.types.sections.sec2.singular}}</h2>
      <div class="sub">{{translate?.setup.modules.types.messages.defineDetailsOfThis}} {{translate?.setup.modules.types.sections.sec2.singular | lowercase}}</div>
    </div>

    <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="onCancelClick()">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  <form [formGroup]="statusInfoForm">
    <div class="flx-modal__body skim">

      <!-- Category -->
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.setup.modules.types.fields.category.singular}}
          <span>
            <i class="fa-regular fa-circle-info fa-xs" pTooltip="{{translate?.setup.modules.picklist.asset.status.messages.statusCategories}} {{translate?.asset.label.singular}} {{translate?.setup.modules.picklist.asset.status.messages.analyticCalc}}"></i>
          </span>
        </label>
        <div class="field-row field-row--auto">
          <p-dropdown
            placeholder="{{translate?.general.buttons.select2.singular}} a {{translate?.setup.modules.types.fields.category.singular | lowercase}}"
            formControlName="statusCategory"
            [filter]="true"
            [showClear]="statusInfoForm.get('statusCategory')?.value ? true : false"
            [options]="statusCategories"
          >
          </p-dropdown>
        </div>
        <span class="hint">{{translate?.setup.modules.types.messages.usedForCalc}} {{translate?.report.label.plural | lowercase}} {{translate?.setup.modules.types.messages.andFilters}}</span>
        <div
          class="p-error text-10"
          *ngIf="statusInfoForm.get('statusCategory').touched && statusInfoForm.get('statusCategory').invalid"
        >
          <span>{{ translate?.general.validationFE.requiredField }}</span>
        </div>
      </div>

      <!-- Label -->
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.setup.modules.types.fields.label.singular}}</label>
        <div class="field-row field-row--auto">
          <input
            pInputText
            formControlName="statusLabel"
            (keyup)="onLabelChange()"
            placeholder="{{translate?.setup.modules.types.messages.enterA}} {{translate?.setup.modules.types.sections.sec2.singular | lowercase}} {{translate?.setup.modules.types.fields.label.singular | lowercase}}..."
          />
        </div>
        <span class="hint">{{translate?.setup.modules.types.messages.displayedFor}} {{translate.setup.users.users.label.plural | lowercase}} {{translate?.setup.modules.types.messages.on}} {{translate?.asset.label.singular | lowercase}} {{translate?.setup.modules.types.messages.recordsList}}</span>
        <div
          class="p-error text-10"
          *ngIf="statusInfoForm.get('statusLabel').touched && statusInfoForm.get('statusLabel').invalid"
        >
          <span>{{ translate?.general.validationFE.requiredField }}</span>
        </div>
      </div>

      <!-- Code -->
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.setup.modules.types.fields.code.singular}}</label>
        <div class="field-row field-row--auto">
          <input
            pInputText
            formControlName="statusCode"
            placeholder="{{translate?.setup.modules.types.messages.enterA}} {{translate?.setup.modules.types.sections.sec2.singular | lowercase}} {{translate?.setup.modules.types.fields.code.singular | lowercase}}..."
            [readonly]="true"
          />
        </div>
        <span class="hint">{{translate?.setup.modules.types.messages.shortUniqueIdentifier}}</span>
        <div
          class="p-error text-10"
          *ngIf="statusInfoForm.get('statusCode').touched && statusInfoForm.get('statusCode').invalid"
        >
          <span>{{ translate?.general.validationFE.requiredField }}</span>
        </div>
      </div>

      <!-- Color -->
      <div class="status-field">
        <label class="field-label mandatory">{{translate?.setup.modules.types.fields.color.singular}}</label>
        <div class="field-row field-row--auto_colorpick">
          <input
            pInputText
            placeholder="#FFFFFF"
            formControlName="statusColor"
            [readonly]="true"
          />
          <div class="w-30px">
            <p-colorPicker
              formControlName="defaultColor"
              (onChange)="onColorPickerChange($event)"
            ></p-colorPicker>
          </div>
        </div>
        <div
          class="p-error text-10"
          *ngIf="statusInfoForm.get('statusColor').touched && statusInfoForm.get('statusColor').invalid"
        >
          <span>{{ translate?.general.validationFE.requiredField }}</span>
        </div>
      </div>

    </div>

    <!-- Section 2: Availability -->
    <div class="flx-modal__header-inline">
      <div class="with-desc">
        <h2>2. {{translate?.setup.modules.types.messages.availability}}</h2>
        <div class="sub">{{translate?.setup.modules.types.messages.chooseWhich}} {{translate?.asset.label.singular | lowercase}} {{translate?.setup.modules.types.label.plural | lowercase}} {{translate?.setup.modules.types.messages.canUseThis}} {{translate?.setup.modules.types.sections.sec2.singular | lowercase}}</div>
      </div>
    </div>

    <div class="flx-modal__body">
      <div class="status-field">
        <label class="field-label">{{translate?.setup.modules.types.messages.addStatusTo}} {{translate?.asset.label.singular | lowercase}} {{translate?.setup.modules.types.label.plural | lowercase}}</label>
        <div class="field-row field-row--auto_colorpick">
          <p-dropdown
            class="w-100"
            [options]="assetTypes"
            placeholder="{{translate?.general.buttons.select2.singular}} {{translate?.asset.label.singular | lowercase}} {{translate?.setup.modules.types.label.plural | lowercase}}"
            formControlName="assetType"
            optionLabel="name"
            [filter]="true"
            optionValue="id"
            (onChange)="onAddAssetType()"
          >
          </p-dropdown>
        </div>
        <span class="hint">{{translate?.setup.modules.types.messages.this}} {{translate?.setup.modules.types.sections.sec2.singular | lowercase}} {{translate?.setup.modules.types.messages.willOnlyBe}} {{translate?.asset.label.singular | lowercase}} {{translate?.setup.modules.types.label.plural | lowercase}} {{translate?.setup.modules.types.messages.listedAbove}}</span>
      </div>

      <div class="status-chip-row" *ngIf="assetTypeAssignments?.length > 0">
        <div
          class="status-chip status-chip--profile"
          *ngFor="let asset of assetTypeAssignmentsSpliced; index as i"
        >
          <span class="status-chip__text">{{ asset?.name }}</span>
          <button
            type="button"
            [hidden]="asset?.id == data?.joTypeId && !data?.mode"
            class="status-chip__remove"
            (click)="removeAssetType(asset, i)"
          >
            <i class="fa-regular fa-xmark"></i>
          </button>
        </div>

        <button
          type="button"
          (click)="onShowMoreToggle('assetType')"
          class="status-chip-row__toggle" *ngIf="assetTypeAssignments?.length > 10"
        >
          {{ showAllJobTypes ? translate?.general.buttons.showLess.singular : translate?.general.buttons.showMore.singular }}
          <i class="fa-regular fa-circle-ellipsis" *ngIf="!showAllJobTypes"></i>
          <i class="fa-regular fa-circle-chevron-up" *ngIf="showAllJobTypes"></i>
        </button>
      </div>
    </div>
  </form>

  <div class="flx-modal__footer">
    <button type="button" class="custella-btn-white" (click)="onCancelClick()">
      {{ translate?.general.buttons.cancel.singular }}
    </button>
    <p-button
      styleClass="h-32"
      type="button"
      [label]="translate?.general.buttons.confirm.singular"
      (onClick)="onFormSubmit()"
    ></p-button>
  </div>
</div>